import { createSlice } from "@reduxjs/toolkit";
import { convertRolesToSelecteArray } from "utils/userDataUtiles";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    name: null,
    roles: [],
    userId: null,
  },
  reducers: {
    setCredentials: (state, action) => {
      const { userName, roles, userId } = action.payload;
      state.name = userName;

      userName !== "" && localStorage.setItem("name", state.name);
      if (roles) {
        state.roles = convertRolesToSelecteArray(roles);
      }
      localStorage.setItem("roles", JSON.stringify(state.roles));

      if (userId) {
        state.userId = userId;
      }
      localStorage.setItem("userId", state.userId);
    },
    logOut: (state, action) => {
      // TODO: need to ask the server to clean cookie etc
      state.name = null;
      // state.token = null;
    },
  },
});

export const { setCredentials, logOut } = authSlice.actions;

export default authSlice.reducer;

export const selectCurrentUser = (state) => state.auth;
export const selectCurrentUserName = (state) => state.auth.user;
export const selectCurrentRoles = (state) => state.auth.roles;
export const selectUserId = (state) => state.auth.userId;
